const FromArr = [
  {
    title: "企业名称",
    modelvalue: "",
    inputtype: "input",
    inputflag: true,
    fontSize: 14,
    color: "#424E66",
    lableheight: 20,
    types: "text",
    placeholder: "请输入内容",
    width: 270,
    height: 32,
    disabled: false,
    marginLeft: 25,
    marginTop: 30,
    X: true,
  },
  {
    title: "企业类型",
    inputtype: "input",
    inputflag: true,
    fontSize: 14,
    color: "#424E66",
    lableheight: 20,
    X: true,
    types: "text",
    placeholder: "请输入内容",
    width: 270,
    height: 32,
    disabled: false,
    marginLeft: 15,
    marginTop: 30,
  },
  {
    title: "统一社会信用代码",
    inputtype: "input",
    inputflag: true,
    fontSize: 14,
    color: "#424E66",
    lableheight: 20,
    X: true,
    types: "text",
    placeholder: "请输入内容",
    width: 270,
    height: 32,
    disabled: false,
    marginLeft: 15,
    marginTop: 30,
  },
  {
    title: "证照编号",
    inputtype: "input",
    inputflag: true,
    fontSize: 14,
    color: "#424E66",
    lableheight: 20,
    X: false,
    types: "text",
    placeholder: "请输入内容",
    width: 270,
    height: 32,
    disabled: false,
    marginLeft: 25,
    marginTop: 30,
  },
  {
    title: "法定代表人",
    inputtype: "input",
    inputflag: true,
    fontSize: 14,
    color: "#424E66",
    lableheight: 20,
    X: false,
    types: "text",
    placeholder: "请输入内容",
    width: 270,
    height: 32,
    disabled: false,
    marginLeft: 25,
    marginTop: 30,
  },
  {
    title: "经营范围",
    inputtype: "input",
    inputflag: true,
    fontSize: 14,
    color: "#424E66",
    lableheight: 20,
    X: true,
    types: "text",
    placeholder: "请输入内容",
    width: 270,
    height: 32,
    disabled: false,
    marginLeft: 15,
    marginTop: 30,
  },
  {
    title: "起始时间",
    inputtype: "date",
    inputflag: true,
    fontSize: 14,
    color: "#424E66",
    lableheight: 20,
    X: true,
    types: "date",
    placeholder: "请选择日期",
    width: 280,
    disabled: false,
    marginLeft: 25,
    marginTop: 30,
  },
  {
    title: "失效时间",
    inputtype: "date",
    inputflag: true,
    fontSize: 14,
    color: "#424E66",
    lableheight: 20,
    X: true,
    types: "date",
    placeholder: "请选择日期",
    width: 280,
    height: 32,
    disabled: false,
    marginLeft: 25,
    marginTop: 30,
  },
  {
    title: "注册资本",
    inputtype: "input",
    inputflag: true,
    fontSize: 14,
    color: "#424E66",
    lableheight: 20,
    X: false,
    types: "text",
    placeholder: "请输入内容",
    width: 270,
    height: 32,
    disabled: false,
    marginLeft: 25,
    marginTop: 30,
  },
  {
    title: "成立时间",
    inputtype: "date",
    inputflag: true,
    fontSize: 14,
    color: "#424E66",
    lableheight: 20,
    X: false,
    types: "date",
    placeholder: "请选择日期",
    width: 280,
    height: 32,
    disabled: false,
    marginLeft: 25,
    marginTop: -10,
  },
  {
    title: "住所",
    inputtype: "input",
    inputflag: true,
    fontSize: 14,
    color: "#424E66",
    lableheight: 20,
    X: false,
    types: "text",
    placeholder: "请输入内容",
    width: 580,
    height: 32,
    disabled: false,
    marginLeft: 25,
    marginTop: -19,
  },
];
export default FromArr;
